// The admin's languages: the platform registry (internal/platform/i18n/
// languages.json) that has a bundle here (locales/<code>.ts). Adding a
// language is files only: docs/I18N.md.
import registry from "../../../../internal/platform/i18n/languages.json";
import type { Key } from "./en";

export type Language = { code: string; name: string; endonym: string; dir: "ltr" | "rtl"; required: boolean };

// Top-level bundles only (en.ts, ar.ts, fr.ts, pt-BR.ts), not module files.
const bundles = import.meta.glob<{ default: Partial<Record<Key, string>> }>(["./[a-z][a-z].ts", "./[a-z][a-z]-[A-Z][A-Z].ts"], { eager: true });

export const dictionaries: Record<string, Partial<Record<Key, string>>> = {};
for (const [path, mod] of Object.entries(bundles)) {
  const code = path.slice(2, -3);
  if (code !== "languages") dictionaries[code] = mod.default;
}

export const languages: Language[] = (registry as Language[]).filter((l) => l.code in dictionaries);

export const languageOf = (code: string) => languages.find((l) => l.code === code);

// Intl tag: Latin digits in every language (the common choice for Gulf admin tools).
export const intlTag = (code: string) => (code === "en" ? "en" : `${code}-u-nu-latn`);
